import { Fragment } from "react"
import FieldChanger from "../FieldChanger"
import { schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { Callout } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingSection } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface ILandingSettingFormProps {
   
}
const BackgroundForm = (props: ILandingSettingFormProps): JSX.Element => {
    const dataSchema = schema().Section
    const sectionId = useLandingStore((state:ILandingStore) => state.selectedLayer)
    const currentLanding = useLandingStore((state:ILandingStore) => state.currentLanding)
    const data =  currentLanding.sections.find( (section: ILandingSection) => section.id === sectionId)
    if(!data) {
            return <div className="container  mx-2 width-auto">            
                <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                    <div className="small col-12">
                        {__("No section selected")}
                    </div>
                    <div className="micro mt-2 col-12">
                        {__("Select some section")}
                    </div>
                </Callout>
            </div>
        }

    const onChange = (value: any, _field: string, data: any, field: string) => {        
        console.log( value, _field, data, field, )
        const state = useLandingStore.getState().currentLanding
        const newVal = {
            currentLanding : {
                ...currentLanding, 
                sections: state.sections.map((section: ILandingSection) => {
                    if(section.id === sectionId) {
                        return {
                            ...section,
                            [field]: value
                        }
                    }
                    return section
                })
            },
            needUpdate: true
        }        
        console.log( newVal )        
        useLandingStore.setState(newVal)
    }

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto pb-3"> 
            { 
                Object.keys( dataSchema.apollo_fields )
                    .filter(field => dataSchema && 
                        dataSchema.apollo_fields[ field ].tab === "background" && 
                        !dataSchema.apollo_fields[ field ].isHidden 
                    )
                    .map((field: any) => {
                        return <Fragment key={ field }>
                            <FieldChanger 
                                {...dataSchema.apollo_fields[ field ]}
                                field={ field }
                                value={ data[field] }
                                origin={data}
                                onChange={ ( value: any, _field: string, data: any ) => onChange(value, _field, data, field) }
                                notClear
                            />
                        </Fragment>
                    })
            }    
        </div>
    </div>
}
export default BackgroundForm